import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';
import getCurrentBreakpoint, { onBreakpointChange } from '@project/shared/utils/breakpoints/js/breakpoints';

@createModule('TableFilterV2')
/**
 * table-filter module implementation.
 *
 * @author Heiko Frosch <heiko.frosch@namics.com>
 */
export class TableFilterV2 extends TerrificSpec {
	
	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: Function) {
		const $ctx = $(this._ctx);

		// $($ctx)
		// 	.find('.js-toggle-trigger')
		// 	.on('click', this._toggleContainer.bind(this));

		resolve();
	}
	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}
	/**
	 * method to trigger public event
	 *
	 * @returns {void}
	 */
	_triggerChangeEvent() {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx);
	}
}
